import CalendarRoom from "components/CalendarRoom/CalendarRoom";
import Seo from "components/Seo/Seo";

import { FC } from "react";


export interface SalaHorario {
  id: number;
  roomId: string;
  slotsHorario: {
    date?: string;
    startTime: string;
    endTime: string;
    price: string;
  }[];
  capacidad: number; // Nuevo campo agregado
  ubicacion: string; // Nuevo campo agregado
}

export interface PropsRoomCalendar {
  data?: SalaHorario[];

}


const PageRoomCalendar: FC<PropsRoomCalendar> = () => {


  return (
    <div>
      <Seo
        path="/rooms"
        title="Reservar Sala de Karaoke Privada en Barcelona | Online"
        description="Reserva online tu sala privada de karaoke en Barcelona. Salas para 4 a 30 personas, disponibilidad en tiempo real y pago seguro. Elige día, hora y sala en segundos."
        keywords="reservar sala karaoke barcelona, alquiler sala karaoke barcelona, karaoke privado barcelona, salas privadas de karaoke barcelona"
      />
      <CalendarRoom />
    </div>
  );
};
export default PageRoomCalendar;
